import React, { useState } from "react";

import DeliveryDispatchDrList from "./DeliveryDispatchDrList";
import DeliveryDispatchDrForm from "./DeliveryDispatchDrForm";

const DeliveryDispatchDr = () => {
  const [fromIsShown, setFromIsShown] = useState(false);
  const [upData, setUpData] = useState(false);
  const [serviceId, setServiceId] = useState("none");

  return (
    <>
      {fromIsShown ? (
        <DeliveryDispatchDrForm
          addForm={setFromIsShown}
          update={upData}
          sId={serviceId}
        />
      ) : (
        <DeliveryDispatchDrList
          addForm={setFromIsShown}
          update={setUpData}
          sId={setServiceId}
        />
      )}
    </>
  );
};

export default DeliveryDispatchDr;
